var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "table",
      {
        staticClass: "table table-hover table-sm table-bordered table-striped",
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _c("tr", { staticClass: "total_tr" }, [
              _c("td", { attrs: { colspan: "4" } }, [_vm._v("ИТОГО")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.totalFigures.price))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.totalFigures.salary))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.totalFigures.pass))]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "10" } }),
            ]),
            _vm._v(" "),
            _vm._l(_vm.orders, function (order, index) {
              return _c("tr", { key: index }, [
                _c("td", { staticClass: "phone_num" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.mixinPrintOrderNum(order.id)) +
                      "\n        " +
                      _vm._s(_vm.moment(order.report_date, "DD.MM.YYYY")) +
                      "\n        "
                  ),
                  order.sub_status === _vm.subStatus_closedByTablet
                    ? _c("div", [
                        _c("i", { staticClass: "icon-fa icon-fa-tablet" }),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        order.city_id === 0
                          ? "Почта"
                          : (_vm.$AllCities[order.city_id] &&
                              _vm.$AllCities[order.city_id].name) ||
                              "Не определен"
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(order.project_label))]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.moment(order.report_date, "HH:mm:ss")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("p", [
                      _vm._v(_vm._s(order.client_name ?? "не определен")),
                    ]),
                    _vm._v(" "),
                    _vm._l(order.phones, function (p, ind) {
                      return _c("p", { key: ind, staticClass: "phone_num" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.mixinPrintPhone(p.phone.full_phone)) +
                            "\n        "
                        ),
                      ])
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "td",
                  _vm._l(order.details, function (drug, ind) {
                    return _c("div", { key: ind }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(drug.drug.title) +
                          " (" +
                          _vm._s(drug.drug_id) +
                          ") - " +
                          _vm._s(drug.qty / (drug.pack_set || 1)) +
                          "\n          "
                      ),
                      drug.pack_set !== 1
                        ? _c(
                            "div",
                            { staticClass: "alert alert-danger m-0 p-1 mb-1" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(drug.qty / (drug.pack_set || 1)) +
                                  " комплект (" +
                                  _vm._s(drug.qty) +
                                  " зав.упак.)\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex pack_details_block" },
                        [
                          drug.drug.holod
                            ? [
                                _c("div", [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: {
                                          content: "Требуется хладоген",
                                          placement: "bottom-center",
                                          classes: ["info"],
                                          targetClasses: ["it-has-a-tooltip"],
                                          offset: 20,
                                          delay: {
                                            show: 500,
                                            hide: 300,
                                          },
                                        },
                                        expression:
                                          "{\n                      content: 'Требуется хладоген',\n                      placement: 'bottom-center',\n                      classes: ['info'],\n                      targetClasses: ['it-has-a-tooltip'],\n                      offset: 20,\n                      delay: {\n                        show: 500,\n                        hide: 300\n                      }\n                    }",
                                      },
                                    ],
                                    staticClass: "icon icon-snowflake pointer",
                                  }),
                                ]),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          drug.drug.commentsbypak
                            ? [
                                _c("div", [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: {
                                          content: drug.drug.commentsbypak,
                                          placement: "bottom-center",
                                          classes: ["info"],
                                          targetClasses: ["it-has-a-tooltip"],
                                          offset: 20,
                                          delay: {
                                            show: 500,
                                            hide: 300,
                                          },
                                        },
                                        expression:
                                          "{\n                      content: drug.drug.commentsbypak,\n                      placement: 'bottom-center',\n                      classes: ['info'],\n                      targetClasses: ['it-has-a-tooltip'],\n                      offset: 20,\n                      delay: {\n                        show: 500,\n                        hide: 300\n                      }\n                    }",
                                      },
                                    ],
                                    staticClass: "icon-fa icon-fa-info-circle",
                                  }),
                                ]),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          drug.drug.computation_comment
                            ? [
                                _c("i", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content: drug.drug.computation_comment,
                                        placement: "bottom-center",
                                        classes: ["info"],
                                        targetClasses: ["it-has-a-tooltip"],
                                        offset: 20,
                                        delay: {
                                          show: 500,
                                          hide: 300,
                                        },
                                      },
                                      expression:
                                        "{\n                    content: drug.drug.computation_comment,\n                    placement: 'bottom-center',\n                    classes: ['info'],\n                    targetClasses: ['it-has-a-tooltip'],\n                    offset: 20,\n                    delay: {\n                      show: 500,\n                      hide: 300\n                    }\n                  }",
                                    },
                                  ],
                                  staticClass: "icon-fa icon-fa-home",
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(order.price))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        (order.extra_options && order.extra_options.salary) || 0
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        order.price -
                          ((order.extra_options &&
                            order.extra_options.salary) ||
                            0)
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v("\n        " + _vm._s(order.address) + "\n      "),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        (_vm.runners[order.runner_id] &&
                          _vm.runners[order.runner_id].name) ||
                          `не определен (${order.runner_id})`
                      ) +
                      "\n      "
                  ),
                ]),
              ])
            }),
            _vm._v(" "),
            _c("tr", { staticClass: "total_tr" }, [
              _c("td", { attrs: { colspan: "4" } }, [_vm._v("ИТОГО")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.totalFigures.price))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.totalFigures.salary))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.totalFigures.pass))]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "10" } }),
            ]),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("№")]),
        _vm._v(" "),
        _c("th", [_vm._v("Доставка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Клиент")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Общая сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("З/П курьера")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма к сдаче")]),
        _vm._v(" "),
        _c("th", [_vm._v("Адрес")]),
        _vm._v(" "),
        _c("th", [_vm._v("Курьер")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }